import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../infrastructure/redux/store';

import { Container, Input } from './styles';

export interface Props {
  width?: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

const SearchBar: React.FC<Props> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  return (
    <Container width={props.width}>
      <Input
        type='search'
        onChange={(e) => props.onSearch(e.target.value.trim())}
        placeholder={props.placeholder}
        autoFocus={props.autoFocus}
      />
      <FaSearch size={18} color={theme.colors.textBackground} />
    </Container>
  );
};

export { SearchBar };
